import apiService from "./apiService";

const bulkLeadService = {
  /**
   * Download lead template as Excel file
   */
  downloadTemplate: async () => {
    try {
      const response = await apiService.get("/leads/bulk/template", {
        responseType: "blob",
      });
      
      // Create blob and download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "lead_template.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    } catch (error) {
      console.error("Error downloading template:", error);
      return {
        success: false,
        error: error.message || "Failed to download template",
      };
    }
  },

  /**
   * Get template schema information
   */
  getTemplateSchema: async () => {
    try {
      const response = await apiService.get("/leads/bulk/schema");
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      console.error("Error getting template schema:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Failed to get template schema",
      };
    }
  },

  /**
   * Upload bulk leads from file
   */
  bulkUploadLeads: async (file, jobId) => {
    try {
      const url = jobId
        ? `/leads/bulk/upload?jobId=${encodeURIComponent(jobId)}`
        : "/leads/bulk/upload";

      const response = await apiService.uploadFile(url, file);

      return {
        success: response.data.success,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      console.error("Error uploading leads:", error);
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "Failed to upload leads",
        data: error.response?.data?.data,
      };
    }
  },

  /**
   * Get bulk upload status by jobId
   */
  getBulkUploadStatus: async (jobId) => {
    try {
      const response = await apiService.get(`/leads/bulk/status/${jobId}`);
      return {
        success: response.data.success,
        data: response.data.data,
      };
    } catch (error) {
      console.error("Error getting bulk upload status:", error);
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "Failed to get bulk upload status",
      };
    }
  },

  /**
   * Cancel bulk upload by jobId and revert partially uploaded data
   */
  cancelBulkUpload: async (jobId) => {
    try {
      const response = await apiService.post(`/leads/bulk/cancel/${jobId}`);
      return {
        success: response.data.success,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      console.error("Error cancelling bulk upload:", error);
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "Failed to cancel bulk upload",
      };
    }
  },
};

export default bulkLeadService;
